import React from 'react';
import {
    SignupNicknameSection,
    NicknameBlock,
    InputElementTitle,
    NicknameInputBlock,
    InputStyle,
    DeleteButton,
    DeleteIcon,
    ErrorBlock,
    ErrorIcon,
    ErrorMessage
} from './style'
import warningIcon from 'images/warning.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-18x18.png';

const SignupNicknameScene = ({
    handleChangeNickname,
    nickname,
    nicknameError,
    setNickname
}) => {
    const nicknameErrorClassName = nicknameError ? 'error_active' : null
    return (
        <SignupNicknameSection>
            <NicknameBlock>
                <InputElementTitle>
                    닉네임 만들기
                </InputElementTitle>
                <NicknameInputBlock>
                    <InputStyle className={nicknameErrorClassName} onChange={handleChangeNickname} value={nickname} maxLength="10" placeholder='닉네임은 2~10 글자로 설정해 주세요' />
                    {nickname.length >= 2 ? (
                        <DeleteButton onClick={() => setNickname('')}>
                            <DeleteIcon src={cancelIcon} />
                        </DeleteButton>
                    ) : null}
                </NicknameInputBlock>
            </NicknameBlock>
            {nicknameError ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon} />
                    <ErrorMessage>{nicknameError}</ErrorMessage>
                </ErrorBlock>
            ) : null}
            
        </SignupNicknameSection>
    );
}

export default SignupNicknameScene;